if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    /* GA4 >> */
    /* if line item will be removed we launch the event pre-rendering */
    const isCartOrMiniCart = (document.querySelector(`#CartItem-${line}`)) ? "Cart" : ((document.querySelector(`#CartDrawer-Item-${line}`)) ? "MiniCart" : "" );
    const oldQty = (isCartOrMiniCart === "Cart") ? parseInt(document.querySelector(`#CartItem-${line}`).dataset.qty) : parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.qty);

    if(quantity <= 0 && isCartOrMiniCart !== "") {
      let objToPush, prodIndex, prodName, prodSku, discount, finalPrice, discountedPrice, prodVariant, item_category1;

      if(isCartOrMiniCart === "Cart") {
        _cartitems.forEach((item,index) => {
          if(item.item_id === document.querySelector(`#CartItem-${line}`).dataset.sku) {
            prodIndex = index;
            prodName = `${item.item_name}`;
            prodSku = item.item_id;
            discount = item.discount;
            finalPrice = item.price;
            discountedPrice = discount > 0 ? finalPrice - discount : finalPrice;
            prodVariant = item.item_variant;
            item_category1 = document.querySelector(`#CartItem-${line}`).dataset.item_category1;
          }
        });
      } else {
        prodIndex = line;
        prodName = document.querySelector(`#CartDrawer-Item-${line}`).dataset.name;
        prodSku = document.querySelector(`#CartDrawer-Item-${line}`).dataset.sku;
        discountedPrice = (parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.discounted_price) / 100);
        finalPrice = (parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.price) / 100);
        discount = (discountedPrice < finalPrice) ? (finalPrice - discountedPrice) : 0;
        prodVariant = document.querySelector(`#CartDrawer-Item-${line}`).dataset.variant;
        item_category1 = document.querySelector(`#CartDrawer-Item-${line}`).dataset.item_category1;
      }

      objToPush = {
        event: "remove_from_cart",
        ecommerce: {
          value: discountedPrice * oldQty,
          items: [
            {
              item_id: prodSku,
              item_name: prodName,
              currency: shopCurrency,
              discount: discount,
              affiliation: (discount > 0) ? "Saldi" : "No Saldi",
              item_brand: ga4Brand,
              item_category: item_category1,
              item_variant: prodVariant,
              price: finalPrice,
              quantity: oldQty
            }
          ]
        }
      };

      if(!objToPush.ecommerce.items[0].item_category) objToPush.ecommerce.items[0].item_category = "Diretto";

      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

      dataLayer.push(objToPush);

      if(isCartOrMiniCart === "Cart") {
        _cartitems.splice(prodIndex,1);
        let updateCartTot = 0;
        _cartitems.forEach(item => {
          updateCartTot += (item.price - item.discount) * item.quantity;
        });
        if(updateCartTot > 0){
          _cga4Cart(updateCartTot)
        } else {
          _cga4Cart()
        }
      }
    }
    /* << GA4 */

    fetch(window.routes.cart_change_url, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          if (document.querySelector('body.template-cart')){
            Shopify.getCart(function(cart) {
          const parsedState = JSON.parse(state);

          /* GA4 >> */
          /* if line item will not be removed we launch the event after rendering */
          if(quantity > 0 && this.currentItemCount !== parsedState.item_count) {

            let eventToPush, objToPush, prodIndex, prodName, prodSku, discount, finalPrice, discountedPrice, prodVariant, item_category1, itemQty, newQty;

            if(isCartOrMiniCart === "Cart") {
              _cartitems.forEach((item,index) => {
                if(item.item_id === document.querySelector(`#CartItem-${line}`).dataset.sku) {
                  newQty = parseInt(document.querySelector(`#CartItem-${line} .quantity__input`).value);
                  prodIndex = index;
                  prodName = `${item.item_name}`;
                  prodSku = item.item_id;
                  discount = item.discount;
                  finalPrice = item.price;
                  discountedPrice = discount > 0 ? finalPrice - discount : finalPrice;
                  prodVariant = item.item_variant;
                  item_category1 = document.querySelector(`#CartItem-${line}`).dataset.item_category1;
                }
              });
            } else {
              newQty = parseInt(document.querySelector(`#CartDrawer-Item-${line} .quantity__input`).value);
              prodIndex = line;
              prodName = document.querySelector(`#CartDrawer-Item-${line}`).dataset.name;
              prodSku = document.querySelector(`#CartDrawer-Item-${line}`).dataset.sku;
              discountedPrice = (parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.discounted_price) / 100);
              finalPrice = (parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.price) / 100);
              discount = (discountedPrice < finalPrice) ? (finalPrice - discountedPrice) : 0;
              prodVariant = document.querySelector(`#CartDrawer-Item-${line}`).dataset.variant;
              item_category1 = document.querySelector(`#CartDrawer-Item-${line}`).dataset.item_category1;
            }

            const actionType = (oldQty < newQty) ? 'increase' : 'decrease';

            switch(actionType) {
              case "increase":
                eventToPush = "add_to_cart";
                itemQty = Math.abs(oldQty - newQty);
                if(isCartOrMiniCart === "Cart") {
                  _cartitems[prodIndex].quantity = _cartitems[prodIndex].quantity + itemQty;
                }
                break;
              case "decrease":
                eventToPush = "remove_from_cart";
                itemQty = Math.abs(oldQty - newQty);
                if(isCartOrMiniCart === "Cart") {
                  _cartitems[prodIndex].quantity = _cartitems[prodIndex].quantity - itemQty;
                }
                break;
              default:
                console.log('No case found');
            }

            objToPush = {
              event: eventToPush,
              ecommerce: {
                value: discountedPrice * itemQty,
                items: [
                  {
                    item_id: prodSku,
                    item_name: prodName,
                    currency: shopCurrency,
                    discount: discount,
                    affiliation: ( discount > 0 ) ? "Saldi" : "No Saldi",
                    item_brand: ga4Brand,
                    item_category: item_category1,
                    item_variant: prodVariant,
                    price: finalPrice,
                    quantity: itemQty
                  }
                ]
              }
            };

            if(!objToPush.ecommerce.items[0].item_category) objToPush.ecommerce.items[0].item_category = "Diretto";

            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

            dataLayer.push(objToPush);

            if(isCartOrMiniCart === "Cart") {
              _cga4Cart()
            }
          }
          /* << GA4 */

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          this.disableLoading();
            if(parsedState.item_count != cart.item_count){
              location.reload();
            }
         }.bind(this));
          }
          else
          {
            const parsedState = JSON.parse(state);

            /* GA4 >> */
            /* if line item will not be removed we launch the event after rendering */
            if(quantity > 0 && this.currentItemCount !== parsedState.item_count) {

              let eventToPush, objToPush, prodIndex, prodName, prodSku, discount, finalPrice, discountedPrice, prodVariant, item_category1, itemQty, newQty;

              if(isCartOrMiniCart === "Cart") {
                _cartitems.forEach((item,index) => {
                  if(item.item_id === document.querySelector(`#CartItem-${line}`).dataset.sku) {
                    newQty = parseInt(document.querySelector(`#CartItem-${line} .quantity__input`).value);
                    prodIndex = index;
                    prodName = `${item.item_name}`;
                    prodSku = item.item_id;
                    discount = item.discount;
                    finalPrice = item.price;
                    discountedPrice = discount > 0 ? finalPrice - discount : finalPrice;
                    prodVariant = item.item_variant;
                    item_category1 = document.querySelector(`#CartItem-${line}`).dataset.item_category1;
                  }
                });
              } else {
                newQty = parseInt(document.querySelector(`#CartDrawer-Item-${line} .quantity__input`).value);
                prodIndex = line;
                prodName = document.querySelector(`#CartDrawer-Item-${line}`).dataset.name;
                prodSku = document.querySelector(`#CartDrawer-Item-${line}`).dataset.sku;
                discountedPrice = (parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.discounted_price) / 100);
                finalPrice = (parseInt(document.querySelector(`#CartDrawer-Item-${line}`).dataset.price) / 100);
                discount = (discountedPrice < finalPrice) ? (finalPrice - discountedPrice) : 0;
                prodVariant = document.querySelector(`#CartDrawer-Item-${line}`).dataset.variant;
                item_category1 = document.querySelector(`#CartDrawer-Item-${line}`).dataset.item_category1;
              }

              const actionType = (oldQty < newQty) ? 'increase' : 'decrease';

              switch(actionType) {
                case "increase":
                  eventToPush = "add_to_cart";
                  itemQty = Math.abs(oldQty - newQty);
                  if(isCartOrMiniCart === "Cart") {
                    _cartitems[prodIndex].quantity = _cartitems[prodIndex].quantity + itemQty;
                  }
                  break;
                case "decrease":
                  eventToPush = "remove_from_cart";
                  itemQty = Math.abs(oldQty - newQty);
                  if(isCartOrMiniCart === "Cart") {
                    _cartitems[prodIndex].quantity = _cartitems[prodIndex].quantity - itemQty;
                  }
                  break;
                default:
                  console.log('No case found');
              }

              objToPush = {
                event: eventToPush,
                ecommerce: {
                  value: discountedPrice * itemQty,
                  items: [
                    {
                      item_id: prodSku,
                      item_name: prodName,
                      currency: shopCurrency,
                      discount: discount,
                      affiliation: ( discount > 0 ) ? "Saldi" : "No Saldi",
                      item_brand: ga4Brand,
                      item_category: item_category1,
                      item_variant: prodVariant,
                      price: finalPrice,
                      quantity: itemQty
                    }
                  ]
                }
              };

              if(!objToPush.ecommerce.items[0].item_category) objToPush.ecommerce.items[0].item_category = "Diretto";

              dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

              dataLayer.push(objToPush);

              if(isCartOrMiniCart === "Cart") {
                _cga4Cart()
              }
            }
            /* << GA4 */

            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));

            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
            }
            this.disableLoading();
            if(parsedState.item_count != cart.item_count){
              location.reload();
            }
          }
        }).catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      //errors.textContent = window.cartStrings.error;
      this.disableLoading();
    });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
      );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(window.routes.cart_update_url, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

function addToCart(body) {
  return new Promise((resolve, reject) => {
       fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          const cart = document.querySelector('cart-drawer');
          cart.renderContents(data);
  
          const currentUrl = window.location.href
          fetch(currentUrl, {
            method: "GET",
          })
          .then(response => {
              return response.text();
          })
          .then(data => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, "text/html");
               
              let checkCartDrawerFg = document.querySelector(".cart-items");
              if (checkCartDrawerFg) {
                  checkCartDrawerFg.innerHTML = doc.querySelector(".cart-items").innerHTML;
                  $('.drawer').addClass('active');
              }

            resolve();
          })
          .catch(error => {
              console.error('Ошибка:', error);
            reject(error)
          });
        })
        .catch(error => {
          console.log('Ошибка:', error);
           reject(error)
        });
  });
}

 //for sample
function removeSampleCart() {
    return new Promise(async (resolve, reject) => {
        const getCart = await fetch('/cart.js');
        const cartPorduct = await getCart.json();
  
        const sampleIds = cartPorduct.items.filter((item) => item.properties._sample);
  
        if(sampleIds && sampleIds.length > 0) {
          await fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              }
            })
        }
      
        resolve();
    });
}
 // form samepe end